import { render, staticRenderFns } from "./BackTestHistory.vue?vue&type=template&id=7adf3986&scoped=true&"
import script from "./BackTestHistory.vue?vue&type=script&lang=js&"
export * from "./BackTestHistory.vue?vue&type=script&lang=js&"
import style0 from "./BackTestHistory.vue?vue&type=style&index=0&id=7adf3986&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adf3986",
  null
  
)

export default component.exports